import { getJson } from './http';
import type { ProjectsOverview } from '../../views/CompanyDashboard/types';

export async function fetchProjectsOverview(params: { from?: string; to?: string }, signal?: AbortSignal): Promise<ProjectsOverview> {
  return await getJson<ProjectsOverview>('/projects/overview', params, signal);
}
